const LogOutIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.4688 18.375V20.25C17.4688 22.3178 15.7866 24 13.7188 24H4.29688C2.22906 24 0.546875 22.3178 0.546875 20.25V3.75C0.546875 1.68219 2.22906 0 4.29688 0H13.7188C15.7866 0 17.4688 1.68219 17.4688 3.75V5.625C17.4688 6.14282 17.0491 6.5625 16.5312 6.5625C16.0134 6.5625 15.5938 6.14282 15.5938 5.625V3.75C15.5938 2.71619 14.7526 1.875 13.7188 1.875H4.29688C3.26306 1.875 2.42188 2.71619 2.42188 3.75V20.25C2.42188 21.2838 3.26306 22.125 4.29688 22.125H13.7188C14.7526 22.125 15.5938 21.2838 15.5938 20.25V18.375C15.5938 17.8572 16.0134 17.4375 16.5312 17.4375C17.0491 17.4375 17.4688 17.8572 17.4688 18.375ZM23.8604 10.3896L21.7611 8.29028C21.3949 7.92407 20.8013 7.92407 20.4352 8.29028C20.069 8.65631 20.069 9.24994 20.4352 9.61597L21.9285 11.1094H10.6719C10.1541 11.1094 9.73438 11.5291 9.73438 12.0469C9.73438 12.5647 10.1541 12.9844 10.6719 12.9844H21.9285L20.4352 14.4778C20.069 14.8438 20.069 15.4374 20.4352 15.8035C20.6183 15.9866 20.8582 16.0781 21.0981 16.0781C21.3381 16.0781 21.578 15.9866 21.7611 15.8035L23.8604 13.7042C24.7743 12.7903 24.7743 11.3035 23.8604 10.3896Z"
        fill="var(--primary)"
      />
    </svg>
  );
};

export default LogOutIcon;
